// Use Intl.Segmenter to correctly handle multi-codepoint emoji sequences
// (skin tones, ZWJ families, gender signs, flags etc.)
function splitFirstGrapheme(str) {
  if (!str) return { first: '', rest: '' };
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const segmenter = new Intl.Segmenter();
    const segments = [...segmenter.segment(str)];
    if (segments.length === 0) return { first: '', rest: '' };
    return { first: segments[0].segment, rest: str.slice(segments[0].segment.length) };
  }
  // Fallback for environments without Intl.Segmenter
  const arr = [...str];
  return { first: arr[0], rest: arr.slice(1).join('') };
}

const EMOJI_TEST = /^\p{Emoji}/u;

export function parseCategoryEmoji(categoryName = '') {
  const { first, rest } = splitFirstGrapheme(categoryName.trim());
  if (first && EMOJI_TEST.test(first)) {
    return { emoji: first, name: rest.trimStart() };
  }
  return { emoji: null, name: categoryName };
}

export function getTransactionEmoji(transaction, budgetSettings = {}) {
  // Transfer between cards — must check before income since receiving side has is_income=true
  if (transaction.is_transfer) return '↔️';

  // Income
  if (transaction.is_income && !transaction.is_interest) return '💸';

  // Interest (investment income)
  if (transaction.is_interest) return '🌱';

  // Debt payment
  if (transaction.is_debt_payment) return '🧾';

  // Savings deposit → look up the fund/investment emoji
  if (transaction.is_savings && transaction.transaction_type !== 'withdrawal') {
    if (transaction.account_type === 'fund') {
      const fund = (budgetSettings.sinking_funds || []).find(f => f.id === transaction.account_id);
      if (fund?.emoji) return fund.emoji;
    }
    if (transaction.account_type === 'investment') return '📊';
    return '🏦';
  }

  // Savings withdrawal
  if (transaction.is_savings && transaction.transaction_type === 'withdrawal') return '🏦';

  // Regular expense — check if the category starts with a user-typed emoji
  if (transaction.category) {
    const { emoji } = parseCategoryEmoji(transaction.category);
    if (emoji) return emoji;
  }

  return null; // fall back to icon
}

export function getCategoryDisplayName(categoryName = '') {
  const { name } = parseCategoryEmoji(categoryName);
  return name || categoryName;
}
